(function(window, document, undefined) {
    var GestioneRaccomandazioneService = function(
        $q,
        $http,
        messaggiFctr,
        CONSTANTS
    ) {
        this.raccomandazione = {};
        this.messaggiConferma = [];
        this.forzaControlli = false;
        this.segnalazioniProposta = [];
        this.propostaSegnalata = null;
        this.bloccoAcquisti = false;

        this.promiseAbilitaScontoMassivo = function(idRaccomandazione) {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT +
                    CONSTANTS.REST.SCONTO_MASSIVO +
                    '/' +
                    idRaccomandazione +
                    '/visibilita'
            });
        };

        this.promiseVerificaScontoMassivo = function(
            idRaccomandazione,
            quantitaSconto
        ) {
            return $http.get(
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.SCONTO_MASSIVO +
                '/' +
                idRaccomandazione +
                '/verifica/' +
                quantitaSconto
            );
        };

        this.promiseSalvascontoMassivo = function(
            idRaccomandazione,
            quantitaSconto
        ) {
            return $http.post(
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.SCONTO_MASSIVO +
                '/inserisci/' +
                idRaccomandazione +
                '/' +
                quantitaSconto, {}
            );
        };

        this.promiseCheckProposte = function(codiceRapporto, idRaccomandazione) {
            var url =
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.RACCOMANDAZIONE +
                'raccomandazione/verifica/' +
                idRaccomandazione +
                '/' +
                codiceRapporto;
            return $http.get(url);
        };

        this.checkVerifica = function(response) {
            self.messaggiConferma = [];
            if (!response.result) {
                return false;
            }
            if (!response.result.listasegnalazioni) {
                return true;
            }
            var result = true;
            response.result.listasegnalazioni.segnalazione.foreach(function(
                segnalazione
            ) {
                if (segnalazione.descrizione !== 'ESITO OK') {
                    self.messaggiConferma.push(segnalazione.descrizione);
                    result = false;
                }
            });
            return result;
        };
    };

    GestioneRaccomandazioneService.$inject = [
        '$q',
        '$http',
        'FinMessaggiFctr',
        'FIN_CONSTANTS'
    ];

    angular
        .module('cbl.finanza.mf')
        .service('gestioneRaccomandazioneService', GestioneRaccomandazioneService);
})(window, document);


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/gestioneRaccomandazione/gestioneRaccomandazione.srvc.js
 ** module id = 48
 ** module chunks = 1 2
 **/